import * as Yup from 'yup';
import { MATCHER_PHONE_VERIFICATION_CODE_REGEX } from './MatcherPhoneVerificationCodeRegex';

const matcherPhoneVerificationSchema = Yup.object().shape({
  verification_code: Yup.string()
    .trim()
    .required('Please enter a six‑digit code.')
    .matches(
      MATCHER_PHONE_VERIFICATION_CODE_REGEX,
      'Please enter a six‑digit code.'
    )
});

export { matcherPhoneVerificationSchema };
